import styled from 'styled-components';
import { BlueprintVersion } from '@data/consts';

// Blueprint drives the meter color from `intent`, and the utilization bands are not intents -- there
// is no intent for "light grey" -- so the fill color is set on the meter element directly. Blueprint
// keeps everything else about the bar: structure, size, radius and track.
export const BandProgressBarWrapper = styled.div<{ $fillColor: string }>`
    &&& .${BlueprintVersion}-progress-meter {
        background-color: ${({ $fillColor }) => $fillColor};
    }
`;
